export enum EnumAnnouncementType {
    ConcursoPublico = 'CONCURSO_PUBLICO',
    Enem = 'ENEM',
    Vestibular = 'VESTIBULAR',
    ResidenciaMedica = 'RESIDENCIA_MEDICA',
    Oab = 'OAB',
    ConcursoMilitar = 'CONCURSO_MILITAR',
    Outros = 'OUTROS'
}